import { Switch } from '@mui/material';
import React from 'react';
import Row from './Row';

type Props = {
	checked: boolean;
	onChange: (isChecked: boolean) => void;
	label: string;
	// eslint-disable-next-line react/require-default-props
	'data-testid'?: string;
};

export default ({
	checked,
	onChange,
	label,
	'data-testid': dataTestId
}: Props) => (
	<Row label={label} data-testid={dataTestId}>
		<Switch
			checked={checked}
			onChange={(_, isChecked: boolean) => {
				onChange(isChecked);
			}}
		/>
	</Row>
);
